import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import './MessageBubble.css'

export interface MessageBubbleProps {
  from: 'guest' | 'property'
  /** Nombre del emisor cuando es la propiedad; el huésped aparece como "Tú" */
  author?: ReactNode
  /** Canal legible: "WhatsApp", "Email" */
  channel: ReactNode
  /** Hora, p. ej. "18:40" */
  time: ReactNode
  children: ReactNode
  className?: string
}

/** Burbuja de mensaje en solo lectura (bundle B6): radio 16 con esquina 4 hacia el emisor; huésped en primary-soft a la derecha; meta con canal y hora. */
export function MessageBubble({ from, author, channel, time, children, className }: MessageBubbleProps) {
  const { t } = useTranslation()
  const who = from === 'guest' ? t('v2.ds.message.tu') : author
  return (
    <div className={cx('hp-msg', `hp-msg--${from}`, className)}>
      <div className="hp-msg__text">{children}</div>
      <div className="hp-msg__meta tnum">
        {who} · {channel} · {time}
      </div>
    </div>
  )
}

/** Separador de día centrado. */
export function MessageDayDivider({ children }: { children: ReactNode }) {
  return <div className="hp-msg-day tnum">{children}</div>
}
